"use client"

import { useSelector } from "react-redux"
import NightAudit from "./NightAudit"

const Dashboard = () => {
  // Get user data from Redux store
  const { user } = useSelector((state) => state.auth || {})
  const isAdmin = user?.role === "admin" || user?.is_admin === true || user?.user_type === "admin"

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      {/* Night Audit section (admin only) */}
      {isAdmin && <NightAudit />}

      {/* Other dashboard content */}
      {/* ... rest of your dashboard components ... */}
    </div>
  )
}

export default Dashboard
